export const required = {
  required: true,
  message: '必填项不得为空'
}
// 整数
const intValidator = (val) => {
  return /^[0-9]*$/.test(val);
};

export const rules = {
  empId: [{
    required: true,
    trigger: 'blur'
  }],
  workDay: [{
    required: true,
    message: '请填写工期天数',
    trigger: 'blur'
  }, {
    validator: intValidator,
    message: '请填写整数',
    trigger: 'blur',
  }],
  loseReasonText: [{
    required: true,
    message: '请选择流失原因',
    trigger: 'blur'
  }],
  content: [{
    required: true,
    message: '请输入备注信息',
    trigger: 'blur'
  }],
}